import { useState } from 'react';
import { GiSpeaker, GiSpeakerOff } from 'react-icons/gi';
function Herovideo() {
  const [isMuted, setIsMuted] = useState(true);
  const handleToggleMute = () => {
    setIsMuted(!isMuted);
  };
  return (
    <div className="flex justify-center max-lg:justify-center items-center text-center flex-row max-lg:flex-col relative">
      <span className="absolute left-[100px] xxl:left-[0px] max-md:left-[30px] top-[40px] max-md:top-[10px] transform -translate-x-1/2  bg-sparkle-pattern bg-cover max-md:bg-contain h-32 w-32 xxl:h-40 xxl:w-40 max-ms:w-20 max-md:h-20 bg-no-repeat bg-center shadow-[#f5d29e] z-[150]  max-sm:mt-0 bg-transparent"></span>
      <span className="absolute right-[0px] xxl:right-[-140px] max-sm:right-[-60px] top-[-10px] transform -translate-x-1/2  bg-sparkle-pattern bg-cover h-24 w-24 xxl:h-32 xxl:w-32 max-md:bg-contain max-ms:w-16 max-md:h-16 bg-no-repeat bg-center shadow-[#f5d29e] z-[150]  max-sm:mt-0 bg-transparent"></span>
      <img
        src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723728982/pixa-pie/hero/demo_video_bg.png"
        alt="video"
        className="min-w-full h-full object-contain object-center absolute top-0 left-0 opacity-[90%] max-md:hidden"
      />
      <div className="relative">
        <video
          autoPlay
          loop
          muted={isMuted}
          playsInline
          className="border-2 border-black z-[9999] rounded-3xl w-full h-auto lg:h-[550px] max-lg:h-[350px] max-lg:w-[350px] lg:min-w-[450px] object-cover"
          controls={false}
          preload="none"
        >
          <source
            src="https://res.cloudinary.com/dx6dieevo/video/upload/f_auto,q_auto:good,w_auto/v1723729030/pixa-pie/hero/pixa_demo_video.mp4"
            type="video/mp4"
          />
        </video>
        <button
          type="button"
          className="absolute left-3 lg:left-auto lg:right-3 bottom-3 lg:bottom-auto lg:top-3 z-50 text-5xl"
          onClick={handleToggleMute}
        >
          {isMuted ? (
            <GiSpeakerOff className="text-[#ffbf73] text-4xl" />
          ) : (
            <GiSpeaker className="text-[#ffbf73] text-3xl" />
          )}
        </button>
      </div>
    </div>
  );
}

export default Herovideo;
